/**
 * Generated by orval v8.5.2 🍺
 * Do not edit manually.
 * Alchemer Dashboard API
 * OpenAPI spec version: 1.0.155
 */

export type DashboardLevel = (typeof DashboardLevel)[keyof typeof DashboardLevel];

export const DashboardLevel = {
  Standard: 'Standard',
  Advanced: 'Advanced',
} as const;
